module.exports = __webpack_public_path__ + "static/media/afirme-logo.ed4d411e.svg";